export default __webpack_public_path__ + "static/media/Stern.5cb25068.png";